import styled from "styled-components";
import Container from "../../atoms/Container/Container.styled";
import {
  withAnchorOffset,
  withDisplayHeading,
  withSectionSpacing,
} from "../../../themes/mixins";
import { deviceMax } from "../../../utils/device";

export const CustomersSection = styled.section`
  ${withSectionSpacing()};
  ${withAnchorOffset()};
  background: ${({ theme }) => theme.colors.white};
`;

export const CustomersWrapper = styled(Container)``;

export const EvidenceHeading = styled.div`
  align-items: flex-end;
  display: flex;
  gap: 48px;
  justify-content: space-between;
  margin-bottom: 40px;

  @media ${deviceMax.tabletWideMax} {
    gap: 35px;
  }

  @media ${deviceMax.phoneMax} {
    display: block;
    margin-bottom: 30px;
  }
`;

export const CustomersTitle = styled.h2`
  ${withDisplayHeading()};

  @media ${deviceMax.tabletWideMax} {
    font-size: 34px;
  }

  @media ${deviceMax.phoneMax} {
    font-size: 35px;
  }
`;

export const CustomerGrid = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr 1fr;

  @media ${deviceMax.phoneMax} {
    gap: 18px;
    grid-template-columns: 1fr;
  }
`;
